import React, { Component } from "react";
import { ErrorNotification, MnemoLoading, Title } from "components/misc";
import { MSelect } from "components/forms";
import { Button, Row, Col } from "design-react-kit";
import { adminService, lessonSectionService, mySleep, stringHelper } from "libs";

export class LessonLiveScheduleProcessVCSectionGroup extends Component {

  state = {
    loading: false,
    loadingError: "",
    idExamSession: 0,
    academicYear: 0,
    students: [],
    sections: [],
    studentPayments: [],
    studentsToSkip: [],
    studentsToExport: [],
  };

  PAYLOAD_YEAR = {
    options: [
      { label: "SELEZIONA UN ANNO ACCADEMICO", value: 0 },
      { label: "2024/2025", value: 2024 },
      { label: "2025/2026", value: 2025 },
    ],
  };

  COURSE_TYPE = {
    76: "ABILITAZIONI60CFU",
    78: "ABILITAZIONI30CFU",
    22: "ABILITAZIONI60CFU",
    24: "ABILITAZIONI30CFU",
    36: "CORSI30ALL2",

  };

  SECTIONGROUP_COMPANY = {
    76: "unitelma",
    78: "unitelma",
    22: "unitelma",
    24: "unitelma",
    36: "unitelma",
  };

  PAYLOAD_EXAMSESSION = {
    2024: {
      options: [
        { label: "SELEZIONA UN CORSO", value: 0 },
        { label: "UNITELMA - 60 CFU", value: 76 },
        { label: "UNITELMA - 30 CFU", value: 78 },
      ],
    },
    2025: {
      options: [
        { label: "SELEZIONA UN CORSO", value: 0 },
        { label: "UNITELMA - 60 CFU", value: 22 },
        { label: "UNITELMA - 30 CFU", value: 24 },
        { label: "UNITELMA - ALLEGATO2 VINCITORI CONCORSO", value: 36 },
      ],
    },
  };

  setAcademicYear = (_, value) => {
    const idExamSession = 0;
    this.setState({ academicYear: value, idExamSession });
  };

  setIdExamSession = (_, value) => {
    this.setState({ idExamSession: value });
  };

  loadStudents = () => {
    this.setState({ loading: true, loadingError: "", studentPayments: [] });
    const { idExamSession, academicYear } = this.state;

    if (idExamSession === 0) {
      ErrorNotification.render(
        "Devi specificare un edizione per poter procedere"
      );
      this.setState({ loading: false });
    } else {
      const courseType = this.COURSE_TYPE[idExamSession];
      const company = this.SECTIONGROUP_COMPANY[idExamSession] || '';
      lessonSectionService
        .listAnalyticsStudents(courseType, idExamSession, academicYear, company)
        .then(({ data }) => {
          const { students, sections, sectionsGroup } = data.payload;
          this.createStudents(students, sections, sectionsGroup);
          this.setState({ students, sections, sectionsGroup, loading: false });
        })
        .catch((error) => {
          console.error("Error ", error);
          ErrorNotification.render("Errore  server");
          this.setState({ loading: false, loadingError: error });
        });
    }
  };

  analyzeStudents = (e) => {
    //for the second click exit
    e.preventDefault();
    if (e.detail > 1) {
      return;
    }

    this.setState({ loading: true, loadingError: "" });
    const { students, idExamSession, academicYear } = this.state;

    if (students.length === 0) {
      ErrorNotification.render("Nessuno studente da analizzare");
      this.setState({ loading: false });
    } else {
      if (idExamSession === 0 || academicYear === 0) {
        ErrorNotification.render(
          "Dati inconsistenti. Ricarica l'elenco degli studenti tramite il pulsante 'Elenco studenti'"
        );
        this.setState({ loading: false });
      } else {
        lessonSectionService
          .createAnalyticsStudents(idExamSession, academicYear)
          .then(({ data }) => {
            this.loadStudents();
            this.setState({ loading: false });
          })
          .catch((error) => {
            console.error("Error ", error);
            ErrorNotification.render("Errore  server");
            this.setState({ loading: false, loadingError: error });
          });
      }
    }
  };

  verifyPaymentStudents = async (e) => {
    //for the second click exit
    e.preventDefault();
    if (e.detail > 1) {
      return;
    }


    this.setState({ loading: true, loadingError: "", studentPayments: [] });
    const { students, studentsToSkip } = this.state;
    let studentPayments = [];

    if (students.length === 0) {
      ErrorNotification.render("Nessuno studente da analizzare");
      this.setState({ loading: false });
    } else {
      for (let i = 0; i < students.length; i++) {
        const student = students[i];

        const skip = studentsToSkip.find(
          (s) => s === student.registrationCode
        );

        if (!skip) {
          // verify if the registration code already sent
          if (studentPayments[student.registrationCode]) {
            continue;
          }
          studentPayments[student.registrationCode] = "invio in corso";

          await mySleep(400); // to avoid too many request at the same time
          
          adminService
            .verifyPayment(student.registrationCode)
            .then(({ data }) => {
              if (data.payload.operation) {
                studentPayments[student.registrationCode] = data.payload.operation;    

                this.setState({ studentPayments: studentPayments });
              }
            })
            .catch((error) => {
              console.error("Error ", error);
              ErrorNotification.render("Errore server");
              studentPayments[student.registrationCode] = "Errore server durante verifica pagamento";
              this.setState({ loading: false, loadingError: error });
            });
         
        } else {
          studentPayments[student.registrationCode] =
            "Percentuale non raggiunta. Pagamento non generato.";
          this.setState({ studentPayments: studentPayments });
        }
       
      }

      this.setState({ loading: false });
    }
  };

  exportStudents = () => {
    const { studentsToExport, sectionsGroup, studentsToSkip } = this.state;

    //iterate on sections and prepare string to add to csv header `str`

    let addSectionHeader = "";
    let addSectionHeader2 = "";

    if (sectionsGroup.length > 0) {

      addSectionHeader2 = sectionsGroup
        .map((section) => `;${section.code}`)
        .join("");
    }

    if (studentsToExport.length === 0) {
      ErrorNotification.render("Nessuno studente da analizzare");
      this.setState({ loading: false });
    } else {
      let str =
        "CODICE REGISTRAZIONE;COGNOME;NOME;EMAIL;TELEFONO;CLASSE CONCORSO;REGIONE;LIMITI RAGGIUNTI" +
        addSectionHeader + addSectionHeader2 + "\r\n";

      let sectionCodes = addSectionHeader.split(";").slice(1); // remove the first empty element

      for (let i = 0; i < studentsToExport.length; i++) {
        const student = studentsToExport[i];
        let limite = "";

        const skip = studentsToSkip.find(
          (s) => s === student.registrationCode
        );
        if (skip) {
          limite = "LIMITE NON RAGGIUNTO";
        }

        let addRow = `${student.registrationCode};${student.surname};${student.name};${student.email};${student.mobile};${student.competitionclass};${student.region};${limite}`;

        // add the relative section value
        let addSectionValues = "";
        sectionCodes.forEach((code) => {

          const studentSection = student[code];
          if (studentSection) {
            addSectionValues += `;${studentSection.percentage}`;
          } else {
            addSectionValues += ';--';
          }
        });

        student.analytics.forEach((item) => {

          addSectionValues += `;${stringHelper.formatPercentage(item.percentage)}`;
        });

        str += addRow + addSectionValues + "\r\n";
      }

      // calcolo il nome della edizione selezionata
      const selectedEdition = this.PAYLOAD_EXAMSESSION[
        this.state.academicYear
      ].options.find(
        (option) => option.value === parseInt(this.state.idExamSession)
      );
      const editionLabel = selectedEdition ? selectedEdition.label : "";

      let downloadLink = document.createElement("a");
      downloadLink.href =
        "data:text/csv;charset=utf-8," + encodeURIComponent(str);
      downloadLink.download =
        "corsisti_esami_" +
        this.state.academicYear +
        "_" +
        editionLabel +
        ".csv";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  };

  createStudents(students, sections, sectionsGroup) {

    let prevStudent = {};
    let currentSections = [...sections];
    let currentSection = {};
    let studentToExport = {};
    const studentsToSkip = [];
    const studentsToExport = [];

    if (students.length === 0) {
      return;
    }

    prevStudent = { registrationCode: students[0].registrationCode, surname: students[0].surname, name: students[0].name, email: students[0].email, mobile: students[0].mobile, competitionclass: students[0].competitionclass, region: students[0].region };
    currentSections = [...sections];

    // for each student create an array of sections with percentage and minutes
    for (let i = 0; i < students.length; i++) {
      const student = students[i];

      if (prevStudent.registrationCode !== student.registrationCode) {

        // aggiunge le sezioni mancanti nelle frequenze (tabelle *resume)
        if (currentSections.length > 0) {

          for (let j = 0; j < currentSections.length; j++) {
            const section = currentSections[j];

            studentToExport[section.code] = { percentage: stringHelper.formatPercentage(0), minutes: 0, totalMinutes: section.totalMinutes };
          }
        }

        studentToExport.registrationCode = prevStudent.registrationCode;
        studentToExport.surname = prevStudent.surname;
        studentToExport.name = prevStudent.name;
        studentToExport.email = prevStudent.email;
        studentToExport.mobile = prevStudent.mobile;
        studentToExport.competitionclass = prevStudent.competitionclass;
        studentToExport.region = prevStudent.region;
        studentsToExport.push(studentToExport);
        studentToExport = {};

        prevStudent = student;
        currentSections = [...sections];
        currentSection = {};

      }     

      if (student.section) {
        // find the section by lessoncode  and remove it from currentSections
        currentSection = currentSections.find(
          (s) =>
            s.code.trim().toLowerCase() === student.section.trim().toLowerCase()
        );

        if (currentSection) {

          const studentPercent = (student.minutes * 1.0) / currentSection.totalMinutes;

          studentToExport[student.section] = {
            percentage: stringHelper.formatPercentage(studentPercent),
            minutes: student.minutes,
            totalMinutes: currentSection.totalMinutes
          };

          // remove curentSection from currentSections array
          currentSections = currentSections.filter(
            (s) =>
              s.code.trim().toLowerCase() !==
              currentSection.code.trim().toLowerCase()
          );
        } else {
          console.error("Section not found for student", student, currentSection);
        }
      }
    }

    // the last student to export is not added in the array, add it now
    if (prevStudent.registrationCode) {
      if (currentSections.length > 0) {
        for (let j = 0; j < currentSections.length; j++) {
          const section = currentSections[j];
          studentToExport[section.code] = { percentage: stringHelper.formatPercentage(0), minutes: 0, totalMinutes: section.totalMinutes };
        }
      }

      studentToExport.registrationCode = prevStudent.registrationCode;
      studentToExport.surname = prevStudent.surname;
      studentToExport.name = prevStudent.name;
      studentToExport.email = prevStudent.email;
      studentToExport.mobile = prevStudent.mobile;
      studentToExport.competitionclass = prevStudent.competitionclass;
      studentToExport.region = prevStudent.region;
      studentsToExport.push(studentToExport);
    }
    
    // for each sections Group, add in the studentToExport the info about percentage and minutes of sectionGroup
    for (let j = 0; j < sectionsGroup.length; j++) {
      const sectionGroup = sectionsGroup[j];

      // get sectionCodes from section array 
      const codes = sectionGroup.idSections.split(',').map(id => {
        const section = sections.find(s => s.id === id.trim());
        return section ? section.code : null;
      });

      // for each student calculate the total minutes and percentage of sectionGroup
      for (let k = 0; k < studentsToExport.length; k++) {

        const student = studentsToExport[k];
        let totalMinutes = 0;
        let totalMinutesAttended = 0;

        codes.forEach((code) => {
          if (student[code]) {
            totalMinutes += parseInt(student[code].totalMinutes);
            totalMinutesAttended += parseInt(student[code].minutes);
          }
        });

        if (!studentsToExport[k].analytics) {
          studentsToExport[k].analytics = [];
        }

        const studentPercent = (totalMinutesAttended * 1.0) / totalMinutes;
        studentsToExport[k].analytics.push({
          code: sectionGroup.code,
          percentage: studentPercent,
          minutes: totalMinutesAttended,
          totalMinutes: totalMinutes
        });

        if (studentPercent < 0.7) {
          studentsToSkip.push(student.registrationCode);
        }
      }
    }

    // order studentsToExport by surname
    studentsToExport.sort((a, b) => a.surname.localeCompare(b.surname));
    this.setState({ studentsToSkip: studentsToSkip, studentsToExport: studentsToExport });
  }

  renderStudents() {

    const { studentsToExport, studentPayments } = this.state;
    let codeSections = "";

    for (let i = 0; i < studentsToExport.length; i++) {
      const student = studentsToExport[i];

      codeSections += `<tr key="${i}"><td>${i + 1}`;

      if (
        studentPayments &&
        studentPayments.hasOwnProperty(student.registrationCode)
      ) {
        codeSections += `<br/>${studentPayments[student.registrationCode]}`;
      }
      codeSections += `</td>`;
      codeSections += `
           <td>${student.registrationCode}</td>
           <td>${student.surname}</td>
           <td>${student.name}</td>
           <td>${student.email}</td>
           <td>${student.mobile}</td>
           <td>${student.competitionclass}</td>
           <td>${student.region}</td>
           <td colSpan="3"></td></tr>`;

      // for each student analytics
      for (let j = 0; j < student.analytics.length; j++) {

        const analytic = student.analytics[j];

        codeSections += `<tr><td colSpan="8"></td>`;

        let label = "";
        if (analytic.percentage < 0.7) {
          label = '<span class="text-red">LIMITE NON RAGGIUNTO</span>';
        }

        codeSections += `
         <td>${analytic.code}</td>
         <td>
           ${stringHelper.formatNumber(analytic.minutes)}/${stringHelper.formatNumber(analytic.totalMinutes)}
         </td>
         <td>
           ${stringHelper.formatPercentage(analytic.percentage)}
           ${label}
         </td>
       </tr>`;
      }
    }

    let codeToReturn = `<table class="MTable table table-striped table-hover">
       <thead>
         <tr>
           <th>#</th>
           <th>Codice registrazione</th>
           <th>Cognome</th>
           <th>Nome</th>
           <th>Email</th>
           <th>Telefono</th>
           <th>Classe di concorso</th>
           <th>Regione</th>
           <th>Attività</th>
           <th>Minuti collegamento</th>
           <th>Frequenza di collegamento</th>
         </tr>
       </thead>
       <tbody>${codeSections}</tbody></table>`;
    return codeToReturn;
  }

  render() {
    const { loading, studentsToExport, academicYear } = this.state;

    return (
      <>
        {loading && <MnemoLoading />}
        <section className="m-4">
          <Title>Analisi frequenza 30/60 CFU e Vincitori di Concorso [Unitelma]</Title>
          <Row>
            <Col md={12}>
              <MSelect
                onChange={this.setAcademicYear}
                id="academicYear"
                payload={this.PAYLOAD_YEAR}
              ></MSelect>
            </Col>
          </Row>
          {academicYear > 0 && (
            <>
              <Row>
                <Col md={6}>
                  <MSelect
                    onChange={this.setIdExamSession}
                    id="idExamSession"
                    payload={this.PAYLOAD_EXAMSESSION[academicYear]}
                  ></MSelect>
                </Col>
              </Row>
            </>
          )}
          <Button
            color="primary bg-dark"
            onClick={() => {
              this.loadStudents();
            }}
          >
            <span className="d-button-label">Elenco studenti</span>
          </Button>
          <Button
            className="ml-2"
            color="primary"
            outline
            onClick={(e) => {
              this.analyzeStudents(e);
            }}
          >
            <span className="d-button-label">Calcola tempo presenza</span>
          </Button>
          {
            <Button
              className="ml-2"
              color="primary"
              outline
              onClick={(e) => {
                this.verifyPaymentStudents(e);
              }}
            >
              <span className="d-button-label">
                Verifica pagamenti aggiuntivi
              </span>
            </Button>
          }
          <Button
            className="ml-2"
            color="primary"
            outline
            onClick={() => {
              this.exportStudents();
            }}
          >
            <span className="d-button-label">Esporta</span>
          </Button>
          <hr />
          {(studentsToExport.length) > 0 && (
            < div
              dangerouslySetInnerHTML={{ __html: this.renderStudents() }}
            ></div>
          )}
        </section>
      </>
    );
  }
}
